module.exports = __webpack_public_path__ + "static/media/2H.6c142beb.svg";